import { useTranslation } from 'react-i18next';
import { Button, Grid2, Typography } from '@mui/material';
import { SentimentVeryDissatisfied } from '@mui/icons-material';
import { usePriceGroupTab } from 'core/contexts/priceGroupTab';

const PriceGroupNoData = ({ isPriceGroupTab = false }) => {
    const { clearFilters: clearFiltersPriceGroupTab, clearFiltersPriceGroup } = usePriceGroupTab();
    const { t: translate } = useTranslation();

    const clearFilters = () => {
        if (isPriceGroupTab) {
            clearFiltersPriceGroupTab();
            return;
        }

        clearFiltersPriceGroup();
    };

    return (
        <Grid2 container mt="32px" flexDirection="column" justifyContent="center" alignItems="center" gap="12px">
            <SentimentVeryDissatisfied sx={{ fontSize: 72, color: 'var(--color-utriper-blue)' }} />
            <Grid2 container flexDirection="column" justifyContent="center" alignItems="center" gap="8px">
                <Typography fontSize={20} fontWeight={700} textAlign="center" sx={{ color: '#131313' }}>
                    {translate('price_group_tab.no_data.title')}
                </Typography>
                <Typography fontSize={16} fontWeight={500} textAlign="center" sx={{ color: '#131313bf' }}>
                    {isPriceGroupTab ? translate('price_group_tab.no_data.description') : translate('price_group_tab_id.no_data.description')}
                </Typography>
            </Grid2>
            <Button sx={{ padding: '14px', minWidth: '48px', borderColor: '#13131340', color: '#131313' }} variant="outlined" onClick={clearFilters}>
                {translate('price_group_tab.no_data.button')}
            </Button>
        </Grid2>
    );
};

export default PriceGroupNoData;
